import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import { Check, AlertTriangle, X } from 'lucide-react';

interface DealAmpelProps {
  status: 'go' | 'maybe' | 'stop';
  percent: number;
}

export function DealAmpel({ status, percent }: DealAmpelProps) {
  const config = {
    go: { icon: Check, label: 'Go!', desc: 'Unter 70%', bg: 'bg-deal-go/15', text: 'text-deal-go' },
    maybe: { icon: AlertTriangle, label: 'Prüfen', desc: '70-75%', bg: 'bg-deal-maybe/15', text: 'text-deal-maybe' },
    stop: { icon: X, label: 'Stop', desc: 'Über 75%', bg: 'bg-deal-stop/15', text: 'text-deal-stop' },
  };

  const { icon: Icon, label, desc, bg, text } = config[status];

  return (
    <motion.div
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className={cn('flex flex-col items-center justify-center rounded-lg p-6', bg)}
    >
      <motion.div
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 0.1, type: 'spring', bounce: 0.5 }}
        className={cn('w-16 h-16 rounded-full flex items-center justify-center mb-3', bg, text)}
      >
        <Icon className="w-8 h-8" />
      </motion.div>
      <span className={cn('text-2xl font-bold', text)}>{label}</span>
      <span className={cn('text-sm', text)}>{percent.toFixed(1)}% All-in</span>
      <span className="text-xs text-foreground-muted mt-1">{desc}</span>
    </motion.div>
  );
}
